import styled from 'styled-components';
import { colorVariables } from 'theme/variables';

export const CheckboxStyled = styled.div`
  position: relative;
`;

export const StyledInput = styled.input`
  display: none;
  margin-right: 10px;
  &:checked ~ div {
    &:after,
    &:before {
      opacity: 1;
    }
`;

export const StyledLabel = styled.label`
  position: relative;
  padding-left: 23px;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  z-index: 1;
`;

export const StyledBox = styled.div`
  position: absolute;
  display: block;
  border-radius: 2px;
  width: 12px;
  height: 12px;
  border: 1px solid ${colorVariables.gray};
  left: 0;
  top: 0;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 6px;
    left: 1px;
    width: 5px;
    height: 1px;
    background-color: ${colorVariables.gray_nightrider};
    transform: rotate(45deg);
    opacity: 0;
    transition: 95ms ease-in-out;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 4px;
    left: 3px;
    width: 11px;
    height: 1px;
    background-color: ${colorVariables.gray_nightrider};
    transform: rotate(-45deg);
    opacity: 0;
    transition: 95ms ease-in-out;
  }
`;
